import script from "./sw-item-parts-picture.vue?vue&type=script&setup=true&lang=js"
export * from "./sw-item-parts-picture.vue?vue&type=script&setup=true&lang=js"

import "./sw-item-parts-picture.vue?vue&type=style&index=0&id=009f6db0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-009f6db0"]])

export default __exports__